package fr.manyverse.app.presentation.dice3d

/** Ce qu'un dé vient de toucher. C'est ce qui donne au choc sa texture sous les doigts. */
enum class DiceImpactKind {
    /** Le feutre du plateau : un choc mat, amorti. */
    FELT,

    /** Un bord de la piste : un claquement sec. */
    WALL,

    /** Un autre dé : le cliquetis bref de deux solides qui s'entrechoquent. */
    DIE
}

/**
 * Un choc de la simulation, prêt à être ressenti. [strength] est normalisée : 0 pour un frôlement
 * qu'on ne sentirait pas, 1 pour un choc de pleine violence. La normalisation est relative à la
 * taille du plateau, si bien qu'un même lancer se ressent pareil dans la piste et en plein écran.
 */
data class DiceImpact(val kind: DiceImpactKind, val strength: Float)
